

function determineTextSkew() {
	
	if (window.innerWidth < 768) {
		removeUnskew();
		var arrayBigLength = arrayBig.length;
	//each image has its own unique id that allows me to change the src of the image. in order to getthe desired skew effect i needed to use two images
	//A pre-skewed image as well as a box version. this condition recognised thewindow size and uses the box image under a certain width.
	//on larger screens the skewed image is used and transitions from a negative skew to 0 skew so thatit presents the pre-skewed image.
		for(i = 0; i < arrayBigLength; i++ ){
		var tile = "bb" + i;
		var element = arrayBig[i];
		document.getElementById(tile).src = element;
		var link = arrayPdfs[i];
		//cut out path to create downloadable file name
		var title = link.slice(80, 95);
		var linkName = "link"+i;

				var module = {
					options: [],
					header: [navigator.platform, navigator.userAgent, navigator.appVersion, navigator.vendor, window.opera],
					dataos: [
						{ name: 'Windows Phone', value: 'Windows Phone', version: 'OS' },
						{ name: 'Windows', value: 'Win', version: 'NT' },
						{ name: 'iPhone', value: 'iPhone', version: 'OS' },
						{ name: 'iPad', value: 'iPad', version: 'OS' },
						{ name: 'Kindle', value: 'Silk', version: 'Silk' },
						{ name: 'Android', value: 'Android', version: 'Android' },
						{ name: 'PlayBook', value: 'PlayBook', version: 'OS' },
						{ name: 'BlackBerry', value: 'BlackBerry', version: '/' },
						{ name: 'Macintosh', value: 'Mac', version: 'OS X' },
						{ name: 'Linux', value: 'Linux', version: 'rv' },
						{ name: 'Palm', value: 'Palm', version: 'PalmOS' }
					],
					databrowser: [
						{ name: 'Chrome', value: 'Chrome', version: 'Chrome' },
						{ name: 'Firefox', value: 'Firefox', version: 'Firefox' },
						{ name: 'Safari', value: 'Safari', version: 'Version' },
						{ name: 'Internet Explorer', value: 'MSIE', version: 'MSIE' },
						{ name: 'Opera', value: 'Opera', version: 'Opera' },
						{ name: 'BlackBerry', value: 'CLDC', version: 'CLDC' },
						{ name: 'Mozilla', value: 'Mozilla', version: 'Mozilla' }
					],
					init: function () {
						var agent = this.header.join(' '),
							os = this.matchItem(agent, this.dataos),
							browser = this.matchItem(agent, this.databrowser);
						
						return { os: os, browser: browser };
					},
					matchItem: function (string, data) {
						var i = 0,
							j = 0,
							html = '',
							regex,
							regexv,
							match,
							matches,
							version;
						
						for (i = 0; i < data.length; i += 1) {
							regex = new RegExp(data[i].value, 'i');
							match = regex.test(string);
							if (match) {
								regexv = new RegExp(data[i].version + '[- /:;]([\\d._]+)', 'i');
								matches = string.match(regexv);
								version = '';
								if (matches) { if (matches[1]) { matches = matches[1]; } }
								if (matches) {
									matches = matches.split(/[._]+/);
									for (j = 0; j < matches.length; j += 1) {
										if (j === 0) {
											version += matches[j] + '.';
										} else {
											version += matches[j];
										}
									}
								} else {
									version = '0';
								}
								return {
									name: data[i].name,
									version: parseFloat(version)
								};
							}
						}
						return { name: 'unknown', version: 0 };
					}
				}
				
				var e = module.init(),
					debug = '';
				
				debug += 'os.name = ' + e.os.name + '<br/>';
				debug += 'os.version = ' + e.os.version + '<br/>';
				debug += 'browser.name = ' + e.browser.name + '<br/>';
				debug += 'browser.version = ' + e.browser.version + '<br/>';
				
				debug += '<br/>';
				debug += 'navigator.userAgent = ' + navigator.userAgent + '<br/>';
				debug += 'navigator.appVersion = ' + navigator.appVersion + '<br/>';
				debug += 'navigator.platform = ' + navigator.platform + '<br/>';
				debug += 'navigator.vendor = ' + navigator.vendor + '<br/>';

		if (e.browser.name === 'Chrome' && e.browser.version >=81  || e.browser.name === 'Firefox' && e.browser.version >=46 || e.browser.name === 'Safari' && e.browser.version >=13 || e.browser.name === 'MSIE' && e.browser.version >=6 || e.browser.name === 'Opera' && e.browser.version >=15 || e.browser.name === 'Mozilla' && e.browser.version >=69 ){
		document.getElementById(linkName).href = "/view-pdf?link="+link;
		
		}
		else{
			document.getElementById(linkName).setAttribute("download", title);
			document.getElementById(linkName).href = link;
		}
		}
		for(i = 0; i < 9; i++ ){
			var spacer = "toppadlarge"+i;
			var space = "0px";
			document.getElementById(spacer).style.paddingTop = space;
		}
	}
	else{
		addUnskew();

		var arraySmallLength = arraySmall.length;
		for(i = 0; i < arraySmallLength; i++ ){
			var tile = "bb" + i;
			var element = arraySmall[i];
			document.getElementById(tile).src = element;
			document.getElementById(tile).style.transform = "skewX(0deg)";
			var linkName = "link"+i;
			var link = arrayPdfs[i];
			//cut out path to create downloadable file name
			var title = link.slice(80, 95);

				var module = {
					options: [],
					header: [navigator.platform, navigator.userAgent, navigator.appVersion, navigator.vendor, window.opera],
					dataos: [
						{ name: 'Windows Phone', value: 'Windows Phone', version: 'OS' },
						{ name: 'Windows', value: 'Win', version: 'NT' },
						{ name: 'iPhone', value: 'iPhone', version: 'OS' },
						{ name: 'iPad', value: 'iPad', version: 'OS' },
						{ name: 'Kindle', value: 'Silk', version: 'Silk' },
						{ name: 'Android', value: 'Android', version: 'Android' },
						{ name: 'PlayBook', value: 'PlayBook', version: 'OS' },
						{ name: 'BlackBerry', value: 'BlackBerry', version: '/' },
						{ name: 'Macintosh', value: 'Mac', version: 'OS X' },
						{ name: 'Linux', value: 'Linux', version: 'rv' },
						{ name: 'Palm', value: 'Palm', version: 'PalmOS' }
					],
					databrowser: [
						{ name: 'Chrome', value: 'Chrome', version: 'Chrome' },
						{ name: 'Firefox', value: 'Firefox', version: 'Firefox' },
						{ name: 'Safari', value: 'Safari', version: 'Version' },
						{ name: 'Internet Explorer', value: 'MSIE', version: 'MSIE' },
						{ name: 'Opera', value: 'Opera', version: 'Opera' },
						{ name: 'BlackBerry', value: 'CLDC', version: 'CLDC' },
						{ name: 'Mozilla', value: 'Mozilla', version: 'Mozilla' }
					],
					init: function () {
						var agent = this.header.join(' '),
							os = this.matchItem(agent, this.dataos),
							browser = this.matchItem(agent, this.databrowser);
						
						return { os: os, browser: browser };
					},
					matchItem: function (string, data) {
						var i = 0,
							j = 0,
							html = '',
							regex,
							regexv,
							match,
							matches,
							version;
						
						for (i = 0; i < data.length; i += 1) {
							regex = new RegExp(data[i].value, 'i');
							match = regex.test(string);
							if (match) {
								regexv = new RegExp(data[i].version + '[- /:;]([\\d._]+)', 'i');
								matches = string.match(regexv);
								version = '';
								if (matches) { if (matches[1]) { matches = matches[1]; } }
								if (matches) {
									matches = matches.split(/[._]+/);
									for (j = 0; j < matches.length; j += 1) {
										if (j === 0) {
											version += matches[j] + '.';
										} else {
											version += matches[j];
										}
									}
								} else {
									version = '0';
								}
								return {
									name: data[i].name,
									version: parseFloat(version)
								};
							}
						}
						return { name: 'unknown', version: 0 };
					}
				}
				
				var e = module.init(),
					debug = '';
				
				debug += 'os.name = ' + e.os.name + '<br/>';
				debug += 'os.version = ' + e.os.version + '<br/>';
				debug += 'browser.name = ' + e.browser.name + '<br/>';
				debug += 'browser.version = ' + e.browser.version + '<br/>';
				
				debug += '<br/>';
				debug += 'navigator.userAgent = ' + navigator.userAgent + '<br/>';
				debug += 'navigator.appVersion = ' + navigator.appVersion + '<br/>';
				debug += 'navigator.platform = ' + navigator.platform + '<br/>';
				debug += 'navigator.vendor = ' + navigator.vendor + '<br/>';
// document.getElementById('log').innerHTML = debug;
		if (e.browser.name === 'Chrome' && e.browser.version >=81  || e.browser.name === 'Firefox' && e.browser.version >=46 || e.browser.name === 'Safari' && e.browser.version >=13 || e.browser.name === 'MSIE' && e.browser.version >=6 || e.browser.name === 'Opera' && e.browser.version >=15 || e.browser.name === 'Mozilla' && e.browser.version >=69 ){
			document.getElementById(linkName).href = "/view-pdf?link="+link;
		
		}else{
			document.getElementById(linkName).setAttribute("download", title);
			document.getElementById(linkName).href = link;	

		}

		
	}
		for(i = 0; i < 9; i++ ){
			var spacer = "toppadlarge"+i;
			var space = "4px";
		document.getElementById(spacer).style.paddingTop = space;
		}
	}
};
// let unskewedNodes = document.getElementById('stripe');
/* This could be improved.... */
function addUnskew() {
	let unskewedNodes = document.getElementById('stripe');
	for (let i = 0; i < unskewedNodes.children.length; i++) {
		if (!unskewedNodes.children[i].classList.contains('unskew')) {
			unskewedNodes.children[i].classList.add('unskew');
		}
	}

}
function removeUnskew() {
	let unskewedNodes = document.getElementById('stripe');
	for (let i = 0; i < unskewedNodes.children.length; i++) {
			if (unskewedNodes.children[i].classList.contains('unskew')) {
			unskewedNodes.children[i].classList.remove('unskew');
			}
	}

}
window.determineTextSkew = determineTextSkew;



